<template>
  <fn-tag
    payback-light
    class="payback-badge"
  >
    <fn-icon
      icon="payback-new"
      size="xs"
    />
    <span class="pb-label">
      {{ $t('payback.label') }}
    </span>
    <span class="pb-points">
      {{ paybackPoints.formattedValue }}
    </span>
  </fn-tag>
</template>

<script>
export default {
  props: {
    paybackPoints: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.payback-badge.tag--payback-light {
  align-items: center;
  font-weight: map-get($font-weights, 'bold');
  color: $color-general-text-loyalty-payback-default;
  border: 0;
  background-color: $color-general-background-partner-payback-low;
  width: min-content;

  &.tag {
    display: flex;
  }

  .pb-label {
    margin-left: 12px;
    font-size: map-get($font-sizes, 's');

    @include bp(m) {
      margin-left: 7px;
    }
  }

  .pb-points {
    margin-left: 10px;
    margin-right: 10px;
    font-size: map-get($font-sizes, 's');
  }
}
</style>
